export const selectRolesData = (state) => state.roles.getIn(['data', 'roles'])
